import React from "react";
import { SacredGeometry } from "@/components/site/SacredGeometry";
import { Particles } from "@/components/site/Particles";

export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section
    data-testid={`page-hero-${(eyebrow || title || "x").toString().toLowerCase().replace(/\s+/g, "-")}`}
    className="relative pt-40 pb-24 overflow-hidden hero-radial"
  >
    {image && (
      <div className="absolute inset-0 -z-10">
        <img src={image} alt="" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-midnight via-midnight/70 to-midnight" />
      </div>
    )}
    <Particles count={18} />
    <div className="pointer-events-none absolute -right-32 top-20 h-[520px] w-[520px] opacity-40">
      <SacredGeometry className="h-full w-full spin-slow" strokeOpacity={0.4} />
    </div>
    <div className="wrap relative z-10 max-w-4xl min-w-0">
      {eyebrow && (
        <div
          className="eyebrow mb-6 break-words"
          style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
        >
          {eyebrow}
        </div>
      )}
      <h1
        className="display text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-ivory break-words"
        style={{ overflowWrap: "anywhere", wordBreak: "break-word", hyphens: "auto" }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          className="mt-6 max-w-2xl text-base sm:text-lg text-ivory/70 leading-relaxed break-words"
          style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
        >
          {subtitle}
        </p>
      )}
      <div className="gold-divider mt-10 max-w-[120px]" />
    </div>
  </section>
);

export default PageHero;
